import React from 'react';
import styles from './RadioHtmlOption.module.css';
import GenericInfoDTO from '../../../interfaces/dto/genericInfoDTO';

export interface RadioHtmlOptionProps {
  option: GenericInfoDTO;
  questionId: number;
  onChange: (newValue: number) => void;
  checked: boolean;
  grayedOut?: boolean;
}

const RadioOption: React.FunctionComponent<RadioHtmlOptionProps> = ({
  option,
  questionId,
  onChange,
  checked,
  grayedOut,
  children,
}) => {
  const { id } = option;

  return (
    <div
      className={`${styles.radioHtmlOptionWrapper} 
        ${grayedOut ? styles.grayedOut : ''}`}
      role="button"
      onKeyPress={() => onChange(option.id)}
      tabIndex={0}
      onClick={() => onChange(option.id)}
    >
      <input
        className={styles.radioInput}
        type="radio"
        id={`${id}`}
        key={`${questionId}-${id}`}
        name={`${questionId}`}
        onChange={() => onChange(option.id)}
        checked={checked}
      />
      {children}
    </div>
  );
};

RadioOption.displayName = 'RadioOption';

export default RadioOption;
